import { useEffect } from "react";

import EcommerceItem from "@/types/gtm/EcommerceItem";
import { QuotePayNowGtmEvent } from "@/types/gtm/QuoteReviewEvent";

import { defaultPayNowData } from "./default-pay-now-data";

export interface ExtendedWindow extends Window {
  dataLayer?: QuotePayNowGtmEvent[];
}

type QuoteReviewPageLoadProps = {
  paymentData: Partial<QuotePayNowGtmEvent | null>;
  policyItems: EcommerceItem[] | null;
  isReady: boolean;
};

const useGtmPayNowOption = (props: QuoteReviewPageLoadProps) => {
  const { paymentData, policyItems, isReady } = props;
  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (paymentData !== null && policyItems !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        const eventData = {
          ...defaultPayNowData,
          ...paymentData,
        };
        if (eventData.ecommerce) eventData.ecommerce.items = policyItems;

        extendedWindow.dataLayer.push({
          ...eventData,
        });
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmPayNowOption;
